module.exports = __webpack_public_path__ + "img/fox-min.c3d94b4f.png";